import React from 'react';
import { Box } from '@mui/material';
import { useParams, useLocation } from 'react-router-dom';
import ActionDetails from '../../components/Actions/ActionDetails';

const ActionView = () => {
  // Get URL parameters using React Router hooks
  const { actionID } = useParams();
  const location = useLocation();
  
  // Get fromScreen from location state or search params
  const fromScreen = location.state?.fromScreen || 
                    new URLSearchParams(location.search).get('fromScreen');

  return (
    <Box sx={{ 
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <ActionDetails 
        actionID={actionID}
        fromScreen={fromScreen}
      />
    </Box>
  );
};

export default ActionView;